module.exports = __webpack_public_path__ + "static/media/wsp-ok.80379a87.svg";